<script setup>
/* eslint-disable */
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import Regions from './PreRegions.vue';
import PreSportTopCompetitions from './PreSportTopCompetitions.vue';
import LeftSidebarFavourites from './LeftSidebarFavourites.vue';
import BetBoostSidebar from './BetBoostSidebar.vue';
import { useFavouritesStore } from '@/stores/favourites';

const router = useRouter();
const favouritesStore = useFavouritesStore();
const isBetBoostsRoute = computed(() => router.currentRoute.value.name === 'pre-sports-bet-boosts');

</script>
<template>
	<template v-if="isBetBoostsRoute">
		<BetBoostSidebar/>
	</template>
	<template v-else>
		<LeftSidebarFavourites v-if="Object.keys(favouritesStore.preLeftSidebarFavourites).length > 0"/>
		<PreSportTopCompetitions/>
		<!-- Regions -->
		<Regions/>
	</template>
</template>